import { BsFillRouterFill, BsInfoCircleFill } from "react-icons/bs";
import { FaHospital, FaUsers, FaUsersCog, FaClipboardList } from "react-icons/fa";
import { FaBedPulse, FaUserGroup } from "react-icons/fa6";
import { IoHardwareChip } from "react-icons/io5";
import { CiSettings } from "react-icons/ci";
import history from '../assets/history.svg';
import patient from '../assets/patient.svg';
import alarm from '../assets/alarm.svg';

export const ROLE_IDS = {
    SUPER_ADMIN: '1',
    ADMIN: '2', 
    DEPARTMENT: '3',
    CARE_GIVER: '4',
    SECURITY: '5',
    LAUNDRY: '6',
    FOOD: '7'
  };
  
  export const ROLE_LANDING_PAGES = {
    [ROLE_IDS.SUPER_ADMIN]: '/institutions',
    [ROLE_IDS.ADMIN]: '/my-patients',
    [ROLE_IDS.DEPARTMENT]: '/my-patients',
    [ROLE_IDS.FOOD]: '/fnb-patients',
    [ROLE_IDS.SECURITY]: '/security-patients',
    [ROLE_IDS.LAUNDRY]: '/housekeeping-patients',
    [ROLE_IDS.CARE_GIVER]: '/my-patients'
  };
  export const ROLE_TO_PERMISSION_KEY = {
    [ROLE_IDS.SUPER_ADMIN]: 'superAdmin',
    [ROLE_IDS.ADMIN]: 'admin',
    [ROLE_IDS.DEPARTMENT]: 'department',
    [ROLE_IDS.CARE_GIVER]: 'careGiver',
    [ROLE_IDS.SECURITY]: 'security',
    [ROLE_IDS.LAUNDRY]: 'laundry',
    [ROLE_IDS.FOOD]: 'food'
};

export const permissions = {
    "superAdmin": [
        {
            "label": "Institutions",
            "path": "institutions",
            "logo": <FaHospital fontSize={56} />
        },
        {
            "label": "Roles",
            "path": "roles",
            "logo": <FaUsers fontSize={56} />
        },
        {
            "label": "Gateway",
            "path": "gateway",
            "logo": <BsFillRouterFill fontSize={56} />
        },
        {
            "label": "Sensors",
            "path": "sensor",
            "logo": <IoHardwareChip fontSize={56} />
        },
        {
            "label": "Info",
            "path": "info",
            "logo": <BsInfoCircleFill fontSize={56} />
        },
    ],
    "admin": [
        {
            "label": "Rooms",
            "path": "my-patients",
            "logo": <FaBedPulse fontSize={56} />
        },
        {
            "label": "Users",
            "path": "users",
            "logo": <FaUserGroup fontSize={56} />
        },
        {
            "label": "Gateway",
            "path": "gateway-admin",
            "logo": <BsFillRouterFill fontSize={56} />
        },
        {
            "label": "Sensors",
            "path": "sensor-admin",
            "logo": <IoHardwareChip fontSize={56} />
        },
        {
            "label": "Settings",
            "path": "alarm-settings",
            "logo": <CiSettings fontSize={56} />
        },

        {
            "label": "History",
            "path": "history",
            "img": history
        },
    ],
    "department": [
        {
            "label": "My Patients",
            "path": "my-patients",
            "img": patient
        },
        {
            "label": "Caregivers",
            "path": "caregiver",
            "logo": <FaUserGroup fontSize={56} />
        },
        {
            "label": "Log Sheet",
            "path": "log-sheet", // <-- ADDED
            "logo": <FaClipboardList fontSize={56} /> // <-- ADDED
        },
        {
            "label": "History",
            "path": "historypage",
            "img": history
        },
        {
            "label": "Info",
            "path": "info",
            "logo": <BsInfoCircleFill fontSize={56} />
        },
    ],
    "food": [
        {
            "label": "Patients",
            "path": "fnb-patients",
            // "logo": <FaUserGroup fontSize={56} />
            "img": patient
        },
        {
            "label": "Log Sheet",
            "path": "log-sheet", // <-- ADDED
            "logo": <FaClipboardList fontSize={56} /> // <-- ADDED
        },
        {
            "label": "History",
            "path": "fnb-history",
            "img": history
        },
        {
            "label": "Info",
            "path": "info",
            "logo": <BsInfoCircleFill fontSize={56} />
        },
    ],
    "security": [
        {
            "label": "Patients",
            "path": "security-patients",
            // "logo": <FaUserGroup fontSize={56} />
            "img": patient
        },
        {
            "label": "Log Sheet",
            "path": "log-sheet", // <-- ADDED
            "logo": <FaClipboardList fontSize={56} /> // <-- ADDED
        },
        {
            "label": "History",
            "path": "security-history",
            "img": history
        },
        {
            "label": "Info",
            "path": "info",
            "logo": <BsInfoCircleFill fontSize={56} />
        },
    ],
    "laundry": [
        {
            "label": "Patients",
            "path": "housekeeping-patients",
            "img": patient
        },
        {
            "label": "Log Sheet",
            "path": "log-sheet", // <-- ADDED
            "logo": <FaClipboardList fontSize={56} /> // <-- ADDED
        },
         {
            "label": "History",
            "path": "housekeeping-history",
            "img": history
        },
        {
            "label": "Info",
            "path": "info",
            "logo": <BsInfoCircleFill fontSize={56} />
        },
    ],
    "careGiver": [
        {
            "label": "My Patients",
            "path": "my-patients",
            "img": patient
        },
        {
            "label": "Log Sheet",
            "path": "log-sheet", // <-- ADDED
            "logo": <FaClipboardList fontSize={56} /> // <-- ADDED
        },
         {
            "label": "History",
            "path": "history",
            "img": history
        },
        {
            "label": "Info",
            "path": "info",
            "logo": <BsInfoCircleFill fontSize={56} />
        },
    ],
}

